export default { Loading: 'Yükleniyor' };
